export default __webpack_public_path__ + "static/Entenda0074-823a021d85f4f66fdfec6430edccb49c.jpg";